// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\ScheduleGridViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthClosure, BerthClosureData, BerthClosureOptions } from 'data/models/BerthClosure';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { UnlistedBerthReservation, UnlistedBerthReservationData, UnlistedBerthReservationOptions } from 'data/models/UnlistedBerthReservation';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { BerthClosureRights, BerthRights, PortCallRights } from 'server/enums/Rights';

// ScheduleGridResponseData is the class that ScheduleGridResponse serializes to/from
export interface ScheduleGridResponseData {
    From : /* ISO8601 */ string;
    To : /* ISO8601 */ string;
	
    BerthClosures : BerthClosureData[] | null;
    BerthReservations : BerthReservationData[] | null;
    ItineraryPoints : ItineraryPointData[] | null;
    PortCalls : PortCallData[] | null;
    UnlistedReservations : UnlistedBerthReservationData[] | null;
    Vessels : VesselData[] | null;
	
    BerthClosureRights : { [key: number]: BerthClosureRights; };
    BerthRights : { [key: number]: BerthRights; };
    CanManageBerths : boolean;
    CanReserveBerths : boolean;
    PortCallRights : { [key: number]: PortCallRights; };
}

// ScheduleGridResponseOptions is the class which may be passed to the ScheduleGridResponse constructor to define optional initial data values
export interface ScheduleGridResponseOptions {
    From : /* ISO8601 */ string;
    To : /* ISO8601 */ string;
	
    BerthClosures? : BerthClosureOptions[] | null;
    BerthReservations? : BerthReservationOptions[] | null;
    ItineraryPoints? : ItineraryPointOptions[] | null;
    PortCalls? : PortCallOptions[] | null;
    UnlistedReservations? : UnlistedBerthReservationOptions[] | null;
    Vessels? : VesselOptions[] | null;
	
    BerthClosureRights? : { [key: number]: BerthClosureRights; };
    BerthRights? : { [key: number]: BerthRights; };
    CanManageBerths? : boolean;
    CanReserveBerths? : boolean;
    PortCallRights? : { [key: number]: PortCallRights; };
}

export class ScheduleGridResponse {
    public From : DataSignal<TZDate>;
    public To : DataSignal<TZDate>;
	
    public BerthClosures : SDataArray<BerthClosure>;
    public BerthReservations : SDataArray<BerthReservation>;
    public ItineraryPoints : SDataArray<ItineraryPoint>;
    public PortCalls : SDataArray<PortCall>;
    public UnlistedReservations : SDataArray<UnlistedBerthReservation>;
    public Vessels : SDataArray<Vessel>;
	
    public BerthClosureRights : DataSignal<{ [key: number]: BerthClosureRights; }>;
    public BerthRights : DataSignal<{ [key: number]: BerthRights; }>;
    public CanManageBerths : DataSignal<boolean>;
    public CanReserveBerths : DataSignal<boolean>;
    public PortCallRights : DataSignal<{ [key: number]: PortCallRights; }>;

    constructor();
    constructor(data : ScheduleGridResponseOptions);
    constructor(data: ScheduleGridResponseOptions | null = null) {
        this.From = jsonableObservable(S.value<TZDate>(data && data.From !== undefined ? new TZDate(data.From) : new TZDate(0), TZDate.eq));
        this.To = jsonableObservable(S.value<TZDate>(data && data.To !== undefined ? new TZDate(data.To) : new TZDate(0), TZDate.eq));
	    
        this.BerthClosures = SArray<BerthClosure>([]);
        this.BerthReservations = SArray<BerthReservation>([]);
        this.ItineraryPoints = SArray<ItineraryPoint>([]);
        this.PortCalls = SArray<PortCall>([]);
        this.UnlistedReservations = SArray<UnlistedBerthReservation>([]);
        this.Vessels = SArray<Vessel>([]);
	    
        this.BerthClosureRights = jsonableObservable(S.value<{ [key: number]: BerthClosureRights; }>(data && data.BerthClosureRights !== undefined ? data.BerthClosureRights : {}));
        this.BerthRights = jsonableObservable(S.value<{ [key: number]: BerthRights; }>(data && data.BerthRights !== undefined ? data.BerthRights : {}));
        this.CanManageBerths = jsonableObservable(S.value<boolean>(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanReserveBerths = jsonableObservable(S.value<boolean>(data && data.CanReserveBerths !== undefined ? data.CanReserveBerths : false));
        this.PortCallRights = jsonableObservable(S.value<{ [key: number]: PortCallRights; }>(data && data.PortCallRights !== undefined ? data.PortCallRights : {}));
    }

    static key(obj : ScheduleGridResponse) {
        return obj.From().toJSON() + '\u2618' + obj.To().toJSON();
    }
    
    static dataKey(obj : ScheduleGridResponseOptions) {
        return new TZDate(obj.From).toJSON() + '\u2618' + new TZDate(obj.To).toJSON();
    }

    static update(obj : ScheduleGridResponse, data : ScheduleGridResponseOptions) {
        S.freeze(() => {
            if (data.From !== undefined) obj.From(new TZDate(data.From));
            if (data.To !== undefined) obj.To(new TZDate(data.To));
	        
	        
            if (data.BerthClosureRights !== undefined) obj.BerthClosureRights(data.BerthClosureRights);
            if (data.BerthRights !== undefined) obj.BerthRights(data.BerthRights);
            if (data.CanManageBerths !== undefined) obj.CanManageBerths(data.CanManageBerths);
            if (data.CanReserveBerths !== undefined) obj.CanReserveBerths(data.CanReserveBerths);
            if (data.PortCallRights !== undefined) obj.PortCallRights(data.PortCallRights);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleGrid.ts